import { FunctionComponent } from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import {
  RadioGroupWithRegister,
  TextInputWithRegister,
} from "src/components/inputs";
import { NEATTOptions } from "src/utils/types";

interface IFinancialGoalsFormProps {
  register: UseFormRegister<any>;
  errors: FieldErrors;
  isPaying: string;
  expectingChange: string;
}

const FinancialGoalsForm: FunctionComponent<IFinancialGoalsFormProps> = ({ register, errors, isPaying, expectingChange }) => (
  <form className="grid grid-cols-2 gap-4">
    <TextInputWithRegister
      register={register("primaryGoal")}
      label="What is your primary financial goal for the next 3-6 months?"
      id="primaryGoal"
      placeholder="..."
      error={errors?.primaryGoal?.message}
    />

    <TextInputWithRegister
      register={register("stepsToImprove")}
      label="What steps have you taken to improve your credit in the past year?"
      id="stepsToImprove"
      placeholder="..."
      error={errors?.stepsToImprove?.message}
    />

    <TextInputWithRegister
      register={register("howToHear")}
      label="How did you hear about our prequalification consulting services?"
      id="howToHear"
      placeholder="..."
      error={errors?.howToHear?.message}
    />

    <RadioGroupWithRegister
      register={register}
      name="experiencedHarships"
      question="Have you experienced any recent financial hardships?"
      options={NEATTOptions.hardshipsOptions}
      error={`${errors?.experiencedHarships?.message || ""}`}
    />

    <RadioGroupWithRegister
      register={register}
      name="percentageIncome"
      question="What percentage of your income goes towards housing costs?"
      options={NEATTOptions.lowPercentRangeOptions}
      error={`${errors?.percentageIncome?.message || ""}`}
    />

    <RadioGroupWithRegister
      register={register}
      name="timeline"
      question="What is the realistic timeline for reaching your goals?"
      options={NEATTOptions.timelineOptions}
      error={`${errors?.timeline?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Have you experienced any recent life changes?"
      name="lifeChanges"
      register={register}
      options={NEATTOptions.YesNoOptions}
      error={`${errors?.lifeChanges?.message || ""}`}
    />

    {expectingChange === NEATTOptions.YesNoUnsure.YES && (
      <RadioGroupWithRegister
        question="Reason?"
        name="lifeType"
        register={register}
        options={NEATTOptions.lifeChangesOptions}
        error={`${errors?.lifeType?.message || ""}`}
      />
    )}

    <RadioGroupWithRegister
      question="Do you have any money set aside for emergencies?"
      name="asideMoney"
      register={register}
      options={NEATTOptions.YesNoOptions}
      error={`${errors?.asideMoney?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Do you have a support system to help with financial decisions?"
      name="supportSystem"
      register={register}
      options={NEATTOptions.YesNoOptions}
      error={`${errors?.supportSystem?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Are you expecting any large expenses in the next 12 months?"
      name="largeExpense"
      register={register}
      options={NEATTOptions.YesNoOptions}
      error={`${errors?.largeExpense?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Do you have any dependents?"
      name="dependents"
      register={register}
      options={NEATTOptions.YesNoOptions}
      error={`${errors?.dependents?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Are you paying or receiving any alimony or child support?"
      name="paying"
      register={register}
      options={NEATTOptions?.YesNoOptions}
      error={`${errors?.paying?.message || ""}`}
    />

    {isPaying === NEATTOptions.YesNoUnsure.YES && (
      <RadioGroupWithRegister
        question="Select the Closest to Your Situation"
        name="payType"
        register={register}
        options={NEATTOptions.alimonyOptions}
        error={`${errors?.payType?.message || ""}`}
      />
    )}
  </form>
);

export default FinancialGoalsForm;
